import React from 'react';
import PropTypes from 'prop-types';

import {
    EventWrapper
} from './Summary.style';

const Event = ({
    event = ''
}) => {
    return (
        <EventWrapper>{event}</EventWrapper>
    );
};

Event.propTypes = {
    event: PropTypes.string
};

export default Event;